import { storableError } from '../../util/errors';

// ================ Action types ================ //
export const FETCH_USER_REQUEST = 'app/AdminUserDetailPage/FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'app/AdminUserDetailPage/FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'app/AdminUserDetailPage/FETCH_USER_ERROR';

export const UPDATE_USER_REQUEST = 'app/AdminUserDetailPage/UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'app/AdminUserDetailPage/UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'app/AdminUserDetailPage/UPDATE_USER_ERROR';

export const DELETE_USER_REQUEST = 'app/AdminUserDetailPage/DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'app/AdminUserDetailPage/DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'app/AdminUserDetailPage/DELETE_USER_ERROR';

// ================ Reducer ================ //
const initialState = {
  fetchInProgress: false,
  fetchError: null,
  updateInProgress: false,
  updateError: null,
  updateSuccess: false,
  deleteInProgress: false,
  deleteError: null,
  user: null,
};

export default function adminUserDetailPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_USER_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null, updateSuccess: false };
    case FETCH_USER_SUCCESS:
      return { ...state, fetchInProgress: false, user: payload };
    case FETCH_USER_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    case UPDATE_USER_REQUEST:
      return { ...state, updateInProgress: true, updateError: null, updateSuccess: false };
    case UPDATE_USER_SUCCESS:
      return { ...state, updateInProgress: false, updateSuccess: true, user: payload };
    case UPDATE_USER_ERROR:
      return { ...state, updateInProgress: false, updateError: payload };
    case DELETE_USER_REQUEST:
      return { ...state, deleteInProgress: true, deleteError: null };
    case DELETE_USER_SUCCESS:
      return { ...state, deleteInProgress: false, user: payload };
    case DELETE_USER_ERROR:
      return { ...state, deleteInProgress: false, deleteError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //
const fetchRequest = () => ({ type: FETCH_USER_REQUEST });
const fetchSuccess = user => ({ type: FETCH_USER_SUCCESS, payload: user });
const fetchError = e => ({ type: FETCH_USER_ERROR, error: true, payload: e });
const updateRequest = () => ({ type: UPDATE_USER_REQUEST });
const updateSuccess = user => ({ type: UPDATE_USER_SUCCESS, payload: user });
const updateError = e => ({ type: UPDATE_USER_ERROR, error: true, payload: e });
const deleteRequest = () => ({ type: DELETE_USER_REQUEST });
const deleteSuccess = user => ({ type: DELETE_USER_SUCCESS, payload: user });
const deleteError = e => ({ type: DELETE_USER_ERROR, error: true, payload: e });

// ================ Selectors ================ //
export const getUser = state => state.AdminUserDetailPage?.user || null;

// ================ Thunks ================ //
export const loadData = params => (dispatch, getState, sdk) => {
  dispatch(fetchRequest());
  const { id } = params;

  return sdk.users
    .show({ id, admin: true })
    .then(response => {
      dispatch(fetchSuccess(response.data.data));
      return response;
    })
    .catch(e => {
      dispatch(fetchError(storableError(e)));
      throw e;
    });
};

export const updateUser = updateParams => (dispatch, getState, sdk) => {
  dispatch(updateRequest());

  return sdk.users
    .adminUpdate(updateParams)
    .then(response => {
      dispatch(updateSuccess(response.data.data));
      return response;
    })
    .catch(e => {
      dispatch(updateError(storableError(e)));
      throw e;
    });
};

export const deleteUser = id => (dispatch, getState, sdk) => {
  dispatch(deleteRequest());

  return sdk.users
    .adminDelete({ id })
    .then(response => {
      dispatch(deleteSuccess(response.data?.data ?? null));
      return response;
    })
    .catch(e => {
      dispatch(deleteError(storableError(e)));
      throw e;
    });
};
